import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { EntriesState } from './types'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state: EntriesState = {
    allEntries: {},
    treeStack: []
}

const entries: Module<EntriesState, RootState> = {
    state,
    actions,
    mutations,
    getters
}

export default entries
